import { useTheme, FONT_SIZE } from '@shopify/polaris-viz-core';
import styles from './TooltipSeriesName.scss.js';
import { jsx } from 'react/jsx-runtime';

function TooltipSeriesName({
  children,
  theme
}) {
  const selectedTheme = useTheme(theme);
  return /*#__PURE__*/jsx("p", {
    className: styles.AxisTitle,
    style: {
      color: selectedTheme.tooltip.titleColor,
      fontSize: FONT_SIZE
    },
    children: children
  });
}

export { TooltipSeriesName };
